import { render, staticRenderFns } from "./PartnerSection.vue?vue&type=template&id=14074edc&scoped=true"
import script from "./PartnerSection.vue?vue&type=script&lang=js"
export * from "./PartnerSection.vue?vue&type=script&lang=js"
import style0 from "./PartnerSection.vue?vue&type=style&index=0&id=14074edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14074edc",
  null
  
)

export default component.exports